<template>
    <div class="content">
        <div class="content-head" v-if="showQuery">
            <el-form :inline="true" class="demo-form-inline">
                <el-form-item label="状态">
                    <el-select v-model="params.Status" placeholder="请选择" class="el-select-medium" style="width: 120px">
                        <el-option label="全部" :value="0"></el-option>
                        <el-option v-for="item in statusopt" :key="item.value" :label="item.label" :value="item.value"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="审核状态">
                    <el-select v-model="params.auditStatus" placeholder="请选择" class="el-select-medium" style="width: 120px">
                        <el-option label="全部" :value="0"></el-option>
                        <el-option v-for="item in auditStatusopt" :key="item.value" :label="item.label" :value="item.value"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="BPM审核状态">
                    <el-select v-model="params.BPMStatus" placeholder="请选择" class="el-select-medium" style="width: 120px">
                        <el-option label="全部" :value="0"></el-option>
                        <el-option v-for="item in BPMStatusopt" :key="item.value" :label="item.label" :value="item.value"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="业务员">
                    <el-select v-model="params.SPCApply_OfficeManID" placeholder="请选择" class="el-select-medium">
                        <el-option label="全部" :value="0"></el-option>
                        <el-option v-for="item in spcOfficeManopt" :key="item.ID" :label="item.OwnerName" :value="item.ID"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="关键字">
                    <el-input v-model="params.keyword" autocomplete="on" name="keyword" placeholder="请输入工程名称、客户名称、项目编号、版本号" clearable class="el-select-big"></el-input>
                </el-form-item>

                <el-form-item label="类型" v-if="isFiltration">
                    <el-select v-model="params.SPCApply_BillType" placeholder="请选择" class="el-select-medium" style="width: 120px">
                        <el-option label="全部" :value="0"></el-option>
                        <el-option v-for="item in spcBillTypeopt" :key="item.value" :label="item.label" :value="item.value"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="来源类型" v-if="isFiltration">
                    <el-select v-model="params.SPCApply_SourceType" placeholder="请选择" class="el-select-medium" style="width: 120px">
                        <el-option label="全部" :value="0"></el-option>
                        <el-option v-for="item in spcSourceTypeopt" :key="item.value" :label="item.label" :value="item.value"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="折扣分组" v-if="isFiltration">
                    <el-select v-model="params.Orders_DiscountCate" placeholder="请选择" class="el-select-medium" value-key="Code">
                        <el-option value="">全部折扣分组</el-option>
                        <el-option v-for="item in Orders_DiscountCateOpt" :key="item.Code" :label="item.Name" :value="item.Code"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="商机编号" v-if="isFiltration">
                    <el-input autocomplete="on" name="pipelinecode" v-model="params.pipelinecode" placeholder="请输入" clearable class="el-select-medium"></el-input>
                </el-form-item>
                <el-form-item label="创建日期" v-if="isFiltration">
                    <el-date-picker v-model="params.date_start" type="date" placeholder="开始日期" value-format="yyyy-MM-dd" clearable></el-date-picker>
                    <span style="margin: 0 5px">至</span>
                    <el-date-picker v-model="params.date_end" type="date" placeholder="结束日期" value-format="yyyy-MM-dd" clearable></el-date-picker>
                </el-form-item>
                <el-form-item label="过期日期" v-if="isFiltration">
                    <el-date-picker v-model="params.dateend_start" type="date" placeholder="开始日期" value-format="yyyy-MM-dd" clearable></el-date-picker>
                    <span style="margin: 0 5px">至</span>
                    <el-date-picker v-model="params.dateend_end" type="date" placeholder="结束日期" value-format="yyyy-MM-dd" clearable></el-date-picker>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="getSpcApplys(true)" icon="el-icon-search" :loading="loadingBtn">搜索</el-button>
                </el-form-item>
                <el-form-item>
                    <el-button @click="onRefresh" icon="el-icon-refresh">重置</el-button>
                </el-form-item>
                <el-form-item>
                    <el-button @click="setFiltration" :icon="!isFiltration ? 'el-icon-arrow-down' : 'el-icon-arrow-up'">
                        {{ !isFiltration ? '展开' : '收起' }}
                    </el-button>
                </el-form-item>
            </el-form>
        </div>
        <div class="content-table">
            <div class="content-table-title" v-if="showQuery">
                报价单管理列表
                <span>
                    <el-dropdown trigger="click" style="margin-left: 10px; margin-right: 10px">
                        <el-button type="primary">
                            导出
                            <i class="el-icon-arrow-down el-icon--right"></i>
                        </el-button>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item>
                                <span @click="getSPCApplysExport()">导出结果信息</span>
                            </el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </span>
            </div>
            <el-table :row-class-name="tableRowClassName" @row-click="handleRowClick" :data="tableData" :height="maxheight" ref="multipleTable" border style="width: 100%" :header-cell-style="{ backgroundColor: '#F5F7FA' }" v-loading="loadingBtn">
                <el-table-column prop="SPCApply_ProjectName" label="工程名称" align="center" show-overflow-tooltip min-width="220" fixed></el-table-column>
                <el-table-column prop="SPCApply_SN" show-overflow-tooltip min-width="120" label="项目编号" align="center"  v-if="showQuery"></el-table-column>
                <el-table-column prop="SPCApply_BillTypeName" label="类型" align="center"></el-table-column>
                <el-table-column prop="SPCApplySourceTypeName" min-width="120" show-overflow-tooltip label="来源类型" align="center"></el-table-column>

                <el-table-column prop="SPCApply_Version" show-overflow-tooltip label="版本号" align="center"></el-table-column>
                <el-table-column prop="SPCApply_CustomerName" label="客户名称" min-width="220" align="center" show-overflow-tooltip></el-table-column>

                <el-table-column prop="SPCApplyStatusName" label="状态" show-overflow-tooltip align="center">
                    <template slot-scope="scope">
                        <span :class="judgeColor(scope.row.SPCApplyStatusName, 'quotationStatus')">{{ scope.row.SPCApplyStatusName }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="SPCApplyAuditStatusName" show-overflow-tooltip label="审核状态" align="center">
                    <template slot-scope="scope">
                        <span :class="judgeColor(scope.row.SPCApplyAuditStatusName)">{{ scope.row.SPCApplyAuditStatusName }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="SPCApplyBPMStatusName" show-overflow-tooltip label="BPM状态" align="center">
                    <template slot-scope="scope">
                        <span :class="judgeColor(scope.row.SPCApplyBPMStatusName)">{{ scope.row.SPCApplyBPMStatusName }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="SPCApply_TotalPrice" min-width="120" show-overflow-tooltip label="项目总金额" align="center">
                    <template slot-scope="scope">￥ {{ scope.row.SPCApply_TotalPrice }}</template>
                </el-table-column>
                <el-table-column prop="BranchOfficeName" min-width="120" show-overflow-tooltip label="已转订单金额" align="center">
                    <template slot-scope="scope">￥{{ scope.row.totalprice }}</template>
                </el-table-column>
                <el-table-column prop="OwnerName" label="业务员" align="center" show-overflow-tooltip></el-table-column>
                <el-table-column prop="SPCApply_BigAreaName" label="大区" align="center" show-overflow-tooltip></el-table-column>
                <el-table-column prop="SPCApply_SmallAreaName" label="小区" align="center" show-overflow-tooltip></el-table-column>
                <el-table-column prop="BranchOfficeName" label="办事处" align="center" show-overflow-tooltip></el-table-column>
                <el-table-column prop="SPCApply_Addtime" label="创建时间" align="center" width="100">
                    <template slot-scope="scope">
                        <div class="">
                            <span>{{ scope.row.SPCApply_Addtime | formatDate }}</span>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column min-width="100" label="操作" align="center" fixed="right" width="150">
                    <template slot-scope="scope">
                        <div class="operation-bar">
                            <span class="operation-bar-block" @click="handleViewsDetail(scope.row)">查看</span>
                            <span class="operation-bar-block" v-if="scope.row.SPCApply_BillType == 0" @click="handleCopy(scope.row)">复制</span>
                            <span class="operation-bar-block" @click="handleViewsDetailToNewWindow(scope.row)">新窗口查看</span>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <div>
                <Pagination :paginationOptions="paginationOptions" @size-change="handleSizeChange" @current-change="handleCurrentChange" />
            </div>
        </div>
    </div>
</template>

<script>
import Pagination from '@/components/Pagination.vue';
import { formatDate, downloadFile } from '@/utils/utils.js';
import { myMixin } from '@/utils/mixin.js';
import store from '@/store';
export default {
    name: 'quotationManagement',
    mixins: [myMixin],
    components: {
        Pagination
    },
    props: {
        showQuery: {
            type: Boolean,
            default: true
        },
        projectName: {
            type: String,
            default: ''
        }
    },
    beforeRouteEnter(to, from, next) {
        if (from.fullPath != '/orderManagement/order') {
            console.log('执行');
            store.commit('SET_ORDERID', '');
        }
        next();
    },
    data() {
        return {
            id: 0,
            loadingBtn: false,
            isDetails: false,
            params: {
                Status: 0,
                auditStatus: 0,
                BPMStatus: 0,
                SPCApply_BillType: 0,
                SPCApply_SourceType: 0,
                date_start: '',
                date_end: '',
                dateend_start: '',
                dateend_end: '',
                SPCApply_OfficeManID: 0,
                keyword: this.showQuery?'':this.projectName,
                pipelinecode: '',
                Orders_DiscountCate: ''
            },
            spcOfficeManopt: [],
            tableData: [],
            Orders_DiscountCateOpt: [],
            currentRow: null,
            statusopt: [
                { label: '待提交', value: 1 },
                { label: '已提交', value: 2 },
                { label: '已取消', value: 3 },
                { label: '已关闭', value: 4 }
            ],
            auditStatusopt: [
                { label: '待审核', value: 1 },
                { label: '审核通过', value: 2 },
                { label: '审核不通过', value: 3 }
            ],
            BPMStatusopt: [
                { label: '未送审', value: 1 },
                { label: '审核中', value: 2 },
                { label: '审核通过', value: 3 },
                { label: '审核不通过', value: 4 },
                { label: '送审失败', value: -1 }
            ],
            spcBillTypeopt: [
                { label: '临时', value: 1 },
                { label: '正式', value: 2 },
                { label: '返货', value: 3 }
            ],
            spcSourceTypeopt: [
                { label: 'SPC报价单', value: 1 },
                { label: '系统生成报价单', value: 2 },
                { label: '非SPC报价单', value: 3 }
            ]
        };
    },
    mounted() {
        console.log(this.$store.state.order.orderId, '========');
        const e = this.$route.query || '';
        if (e) {
            if (e.Orders_SourceCate) {
                this.params.Orders_SourceCate = +e.Orders_SourceCate;
            }
            if (e.auditStatus == 1) {
                this.params.Status = 2;
                this.params.auditStatus = 1;
            }
        }
        this.getOfficeMemberOption();
        this.getSpcApplys();
        this.getDiscountCategorys();
        if (this.$store.state.order.orderId) {
            this.handleViewsDetail(this.$store.state.order.orderId);
        }
    },
    methods: {
        handleSizeChange(newSize) {
            this.paginationOptions.PageSize = newSize;
            this.getSpcApplys();
        },
        handleCurrentChange(newPage) {
            this.paginationOptions.Page = newPage;
            this.getSpcApplys();
        },
        /*
      重置
    */
        onRefresh() {
            this.params = {
                Status: 0,
                auditStatus: 0,
                BPMStatus: 0,
                SPCApply_BillType: 0,
                SPCApply_SourceType: 0,
                date_start: '',
                date_end: '',
                dateend_start: '',
                dateend_end: '',
                SPCApply_OfficeManID: 0,
                keyword: '',
                pipelinecode: '',
                Orders_DiscountCate: ''
            };
            this.getSpcApplys(true);
        },

        filteropt() {
            let params = { ...this.params };
            return { json: JSON.stringify(params), Page: this.paginationOptions.Page, PageSize: this.paginationOptions.PageSize };
        },
        /*
     查询报价单列表
   */
        getSpcApplys(flag = false) {
            this.loadingBtn = true;
            if (flag) {
                this.paginationOptions = {
                    Page: 1,
                    total: 0,
                    PageSize: 40
                };
            }
            this.$newsApi
                .getSpcApplys(this.filteropt())
                .then((res) => {
                    if (res.data.Resultcode == 0) {
                        this.tableData = res.data.data;
                        this.paginationOptions.total = res.data.RecordCount;
                        this.tableData.map((item) => {
                            item.LastUpdateTime = formatDate(item.LastUpdateTime, true);
                        });
                    } else {
                        this.tableData = [];
                        this.paginationOptions.total = 0;
                    }
                })
                .finally(() => (this.loadingBtn = false));
        },
        /*
    导出查询结果
  */
        getSPCApplysExport() {
            let loadingInstance = this.$loading(); // 显示 loading
            this.$newsApi
                .SPCApplysExport(this.filteropt())
                .then((res) => {
                    this.$closeLoading(loadingInstance); // 关闭 loading
                    if (res.data.Resultcode == 0) {
                        downloadFile(res.data.data, res.data.Resultinfo);
                    }
                })
                .finally(() => (this.loadingBtn = false));
        },
        /*
      获取报价单办事处业务员
    */
        getOfficeMemberOption() {
            this.$newsApi.getOfficeMemberOption().then((res) => {
                if (res.data.Resultcode == 0) {
                    this.spcOfficeManopt = res.data.data.map((item) => {
                        return {
                            ...item,
                            OwnerName: item.OwnerName + '[' + item.UserCode + ']'
                        };
                    });
                }
            });
        },
        /*
      查看详情
    */
        handleViewsDetail(row) {
            // 生成带时间戳的URL确保每次都不同
            const timestamp = Date.now();
            const randomId = Math.random().toString(36).substr(2, 9);
            
            // 通过redirect路径实现页面重新渲染
            this.$router.push({
                path: '/redirect/quotationManagement/quotationDetails',
                query: { 
                    id: row.SPCApply_ID,
                    _t: timestamp,
                    _r: randomId
                }
            }).catch(err => {
                // 忽略重复导航错误
                if (err.name !== 'NavigationDuplicated') {
                    console.error('Navigation error:', err);
                }
            });
        },
        handleViewsDetailToNewWindow(row) {
            // 生成带时间戳的URL确保每次都不同
            const timestamp = Date.now();
            const randomId = Math.random().toString(36).substr(2, 9);
            
            const route = this.$router.resolve({
                path: '/quotationManagement/quotationDetails',
                query: { 
                    id: row.SPCApply_ID,
                    _t: timestamp,
                    _r: randomId
                }
            });
            window.open(route.href, '_blank');
        },
        /*
      复制
    */
        handleCopy(row) {
            this.$confirm('确认复制当前订单吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            })
                .then(() => {
                    // 修改：使用window.open在新标签页打开复制页面
                    const route = this.$router.resolve({
                        path: '/quotationManagement/temporarilyPricesheetadd?copySPCApplyDataID='+row.SPCApply_ID
                    });
                    window.open(route.href, '_blank');
                })
                .catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消'
                    });
                });
        },
        /*
      返回列表
    */
        handleClose() {
            this.isDetails = false;
        },
        getDiscountCategorys() {
            this.$newsApi.GetDiscountCategoryByType().then((res) => {
                if (res.data.Resultcode == 0) {
                    this.Orders_DiscountCateOpt = res.data.data;
                }
            });
        },
        /*
        表格行类名
        */
        tableRowClassName({row}) {
            if (this.currentRow && this.currentRow.SPCApply_ID === row.SPCApply_ID) {
                return "current-row";
            }
            return "";
        },
        /*
        点击行选中
        */
        handleRowClick(row) {
            this.currentRow = row;
        }
    }
};
</script>
<style scoped>

.operation-bar {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-evenly;
    gap: 0px;
    white-space: normal;
}
.operation-bar-block {
    font-size: 12px;
    cursor: pointer;
    border-radius: 3px;
    margin: 1px 0;
}
.content-head {
    padding: 15px 20px 5px 20px;
}
.el-form-item--small.el-form-item {
    margin-bottom: 5px;
}
</style>
